import { Box } from '@mui/material';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import React, { useEffect, useState } from 'react';
import useCifaStore from 'stores/cifa/cifa.store';
import { ROUTES } from 'routes/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewTechAssist from './ViewTechAssist';

type TechAssistViewValues = {
  beneficiaries: string;
  ataUuid: string | null;
  parceria: string;
  beneficiariosParceria: string;
  docParceriaUuid: string | null;
  relatorioUuid: string | null;
  instituicoes: string[];
  outraInstituicao: string;
  relatorioUuid_empaer: string | null;
  relatorioUuid_ensino: string | null;
  relatorioUuid_ongs: string | null;
  relatorioUuid_privadas: string | null;
  beneficiarios?: any[];
};

const ViewTechAssistPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cifa } = useCifaStore();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const [values, setValues] = useState<TechAssistViewValues>({
    beneficiaries: '',
    ataUuid: null,
    parceria: '',
    beneficiariosParceria: '',
    docParceriaUuid: null,
    relatorioUuid: null,
    instituicoes: [],
    outraInstituicao: '',
    relatorioUuid_empaer: null,
    relatorioUuid_ensino: null,
    relatorioUuid_ongs: null,
    relatorioUuid_privadas: null,
    beneficiarios: [],
  });

  useEffect(() => {
    if (!cifa.uuid) {
      navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
      return;
    }
    setValues({
      beneficiaries:
        cifa.assistencia_tecnica_beneficiarios_atendidos?.toString() ?? '',
      ataUuid: cifa.assistencia_tecnica_ata_cmdrs_uuid ?? null,
      parceria: cifa.assistencia_tecnica_parceria_instituicao ? 'Sim' : 'Não',
      beneficiariosParceria:
        cifa.assistencia_tecnica_parceria_beneficiarios_atendidos?.toString() ??
        '',
      docParceriaUuid: cifa.assistencia_tecnica_documento_parceria_uuid ?? null,
      relatorioUuid:
        cifa.assistencia_tecnica_parceria_empaer_relatorio_documento_uuid ??
        null,
      instituicoes: [
        ...(cifa.assistencia_tecnica_parceria_empaer ? ['empaer'] : []),
        ...(cifa.assistencia_tecnica_parceria_instituicoes_ensino
          ? ['ensino']
          : []),
        ...(cifa.assistencia_tecnica_parceria_ongs ? ['ongs'] : []),
        ...(cifa.assistencia_tecnica_parceria_outras ? ['privadas'] : []),
      ],
      outraInstituicao: cifa.assistencia_tecnica_parceria_outras_nome ?? '',
      relatorioUuid_empaer:
        cifa.assistencia_tecnica_parceria_empaer_relatorio_documento_uuid ??
        null,
      relatorioUuid_ensino:
        cifa.assistencia_tecnica_parceria_instituicoes_ensino_relatorio_documento_uuid ??
        null,
      relatorioUuid_ongs:
        cifa.assistencia_tecnica_parceria_ongs_relatorio_documento_uuid ?? null,
      relatorioUuid_privadas:
        cifa.assistencia_tecnica_parceria_outras_relatorio_documento_uuid ??
        null,
      beneficiarios: cifa.assistencia_tecnica_beneficiarios ?? [],
    });
  }, [cifa, navigate, anoReferencia, location.pathname]);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header
        title={`CIFA - Visualização da Assistência Técnica - ${anoReferencia}`}
        showBackButton={true}
      />
      <Box
        width='97%'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        margin='2rem'
      >
        <ViewTechAssist values={values} />
      </Box>
    </MenuProvider>
  );
};

export default ViewTechAssistPage;
